<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <vx-card class="w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div slot="no-body" class="full-page-bg-color">
        <div class="vx-row no-gutter justify-center items-center">
          <div class="vx-col hidden lg:block lg:w-1/2">
            <img src="@/assets/images/logo/Logos_BDS-02.png" alt="login" class="mx-auto">
          </div>

          <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
            <div class="px-8 pt-8 login-tabs-container">

              <div class="vx-card__title mb-4">
                <h4 class="mb-4">{{ $t('pages.login.title') }}</h4>
                <p>{{ $t('pages.login.subtitle') }}</p>
              </div>

              <div>
                <validation-observer ref="loginForm" v-slot="{ failed }">
                  <div class="w-full" v-if="errorMessage">
                    <span class="text-xl text-danger"> {{ errorMessage }} </span>
                  </div>

                  <validation-provider vid="email" name="email" rules="required|email" v-slot="{ errors, validate, failed }">
                    <div>
                      <vs-input type="text" icon-no-border icon="icon icon-user" icon-pack="feather"
                                :label-placeholder="$t('fields.email')" @input="validate"
                                v-model.trim="email" :danger="failed"
                                class="w-full"/>
                      <bds-error :text_error="errors[0]"/>
                    </div>
                  </validation-provider>

                  <validation-provider name="password" rules="required|password" v-slot="{ errors, validate, failed }">
                    <div>
                      <vs-input type="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                                :label-placeholder="$t('fields.password')" @input="validate"
                                v-model.trim="password" :danger="failed" @keyup.enter="loginJWT"
                                class="w-full mt-6"/>
                      <bds-error :text_error="errors[0]"/>
                    </div>
                  </validation-provider>

                  <div class="flex flex-wrap justify-center md:justify-between my-5">
                    <div class="w-full md:w-1/2 flex justify-center md:justify-start">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">{{ $t('pages.login.remerberMe') }}</vs-checkbox>
                    </div>

                    <div class="w-full md:w-1/2 flex justify-center md:justify-end">
                      <router-link :to="{ name: 'forgotPassword' }" class="underline">{{ $t('pages.login.forgotPasswordText') }}</router-link>
                    </div>
                  </div>

                  <div class="flex flex-wrap justify-around mb-3">
                    <vs-button class="w-2/3 md:w-1/3 my-1 md:mx-1" type="border"
                               color="warning" :to="{ name: 'register' }">
                      {{ $t('pages.login.register') }}
                    </vs-button>

                    <vs-button class="w-2/3 md:w-1/3 my-1" :disabled="failed" @click="loginJWT">
                      {{ $t('pages.login.login') }}
                    </vs-button>
                  </div>
                </validation-observer>

                <vs-divider> {{ $t('pages.login.divider') }} </vs-divider>
                <div class="flex flex-wrap justify-between mb-3">
                  <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <popup :active-popup="activePopup" :pop-title="$t('pages.login.welcomePopup.title')" v-if="false">
      <template #body>
        <div>
          <p class="text-xl text-primary">
            {{ $t('pages.login.welcomePopup.welcomeMessage') }}
          </p>

          <p class="text-sm text-primary pb-2">
            {{ $t('pages.login.welcomePopup.newHome') }}
          </p>

          <p class="text-red-600 py-1">
            {{ $t('pages.login.welcomePopup.bodyIamOld') }}
          </p>

          <p class="text-blue-600 py-1 pb-2">
            {{ $t('pages.login.welcomePopup.bodyIamNew') }}
          </p>

          <p class="bg-danger px-1">
            <span class="text-sm text-white">
              {{ $t('pages.login.welcomePopup.tip') }}
            </span>
          </p>
        </div>

        <div class="w-full pt-2">
          <span class="text-sm text-primary">
            {{ $t('pages.login.welcomePopup.choose') }}
          </span>
        </div>

        <div class="w-full flex justify-between pt-4">
          <div class="flex justify-around px-3 space-x-2" v-if="false">
            <vs-button type="border" color="dark" :to="{ name: 'register' }" class="bg-blue-600">
              {{ $t('pages.login.welcomePopup.IamNew') }}
            </vs-button>

            <vs-button type="border" color="dark" :to="{ name: 'forgotPassword' }" class="bg-red-600">
              {{ $t('pages.login.welcomePopup.IamHaveALogin') }}
            </vs-button>
          </div>

          <div class="flex justify-end pr-2">
            <vs-button type="border" color="primary" @click="activePopup = false">
              {{ $t('pages.login.welcomePopup.haveDone') }}
            </vs-button>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>


<script>

import GoogleLogin from 'vue-google-login';
import { loginSuccess } from "@/helpers/functionsHelpers";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import popup from './WelcomePopup'
import ProfileService from "@/services/Profile.service";

export default {
  components: {
    GoogleLogin,
    ValidationProvider,
    ValidationObserver,
    popup
  },
  data () {
    return {
      errorMessage: null,
      email: '',
      password: '',
      checkbox_remember_me: false,
      params: {
        client_id: process.env.VUE_APP_GOOGLE_LOGIN_CLIENT_ID
      },

      activePopup: false,

      renderParams: {
        width: 250,
        height: 50,
        longtitle: true
      }
    }
  },
  computed: {
    storeProfileData() {
      return this.$store.getters['Profile/profileInfo'];
    },
  },
  methods: {
    sosWhatsApp() {
      window.open("https://wa.me/message/ML4LRUPSQ5ATE1", "_blank");
    },
    onSuccess(googleUser) {
      console.log(googleUser);
      console.log(googleUser.getBasicProfile());
      var id_token = googleUser.getAuthResponse().id_token;
      const payload = {
        token: id_token,
        method: 'google'
      }
      this.login(payload);
    },
    onFailure() {
      //showNotify(this, true, 'Erro ao logar através do google');
    },
    isLoggedIn() {
      // If user is already logged in notify
      if (this.$store.state.Auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()
        //
        // this.$vs.notify({
        //   title: 'Login Attempt',
        //   text: 'You are already logged in!',
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'warning'
        // })

        return true
      }
      return false
    },
    loginJWT () {
      if (this.isLoggedIn()) {
        this.$router.push({name: 'home'});
        return;
      }

      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          return;
        }

        const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          email: this.email,
          password: this.password,
          method: 'native'
        }
        this.login(payload);

        this.$nextTick(() => {
          this.$refs.loginForm.reset();
        });
      });
    },
    login(payload) {
      const _this = this;
      this.$vs.loading();
      this.$store.dispatch('Auth/login', payload).then((response) => {
        this.$vs.loading.close();
        loginSuccess(_this, response).then(() => {
          this.$nextTick(() => {
            if (this.$store.state.Profile.profileFulfill()) {
              ProfileService.getAnnouncement().then((response) => {
                if (!response.active) {
                  this.$router.push({name: 'home'});
                  return;
                }

                this.$alma.dialogHtml({
                  title: response.title,
                  html: response.body
                }).then(() => {
                  this.$router.push({name: 'home'});
                });
              });
            }
            else { //if profile is incomplete
              this.$alma.dialogHtml({
                title: this.$t('components.fulfillProfile.title'),
                html: this.$t('components.fulfillProfile.body')
              }).then(() => {
                this.$router.push({name: 'profile-settings'});
              });
            }

            // if (this.$store.state.Profile.isPlanner()) {
            //   if (this.$store.state.Profile.isSupervisor()) {
            //     this.$router.push({name: 'cases', params: {filter: 'revision'}});
            //   } else if (this.$store.state.Profile.isAdmin()) {
            //     this.$router.push({name: 'cases', params: {filter: 'revision'}});
            //   } else {
            //     this.$router.push({name: 'cases', params: {filter: 'execute'}});
            //   }
            // } else if (this.$store.state.Profile.isDoctor()) {
            //   this.$router.push({name: 'shop'});
            // }
          });
        });
      }, error => {
        this.$vs.loading.close();
        this.password = null;
        this.errorMessage = error.message;
      });
    },
  },
  mounted() {
    if (this.isLoggedIn()) {
      console.debug('Logged user redirecting to home');
      this.$router.push({name: 'home'});
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>


<!--<template>-->
<!--  <div id="app">-->
<!--    <ValidationProvider ref="provider" rules="required" v-slot="{ errors }">-->
<!--      <input v-model="model" type="text">-->
<!--      <div v-if="errors" v-text="errors[0]"></div>-->
<!--    </ValidationProvider>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--import { ValidationProvider } from "vee-validate";-->

<!--export default {-->
<!--  components: {-->
<!--    ValidationProvider-->
<!--  },-->
<!--  mounted() {-->
<!--    // all those properties are required.-->
<!--    this.$refs.provider.applyResult({-->
<!--      errors: ["this is a backend error"], // array of string errors-->
<!--      valid: false, // boolean state-->
<!--      failedRules: {} // should be empty since this is a manual error.-->
<!--    });-->
<!--  }-->
<!--};-->
<!--</script>-->
